import { View } from './view'

export const FormSection = View
